import * as React from 'react';

const ArrowDownIcon: React.FC<React.SVGProps<SVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    fill="none"
    viewBox="0 0 17 16"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.339 11.001c.176 0 .346-.07.471-.195l4-4a.667.667 0 1 0-.943-.943L8.34 9.392l-3.53-3.529a.667.667 0 1 0-.942.943l4 4a.67.67 0 0 0 .472.195"
    ></path>
  </svg>
);

export default ArrowDownIcon;
